import fetch from '../../../../utils/fetch'
import * as types from './mutation_types'
import Vue from 'vue'

export const retrieve = ({ commit }, id) => {
  commit(types.COMPANY_SHOW_TOGGLE_LOADING)

  return fetch(id)
    .then(response => response.json())
    .then((data) => {
      commit(types.COMPANY_SHOW_TOGGLE_LOADING)
      commit(types.COMPANY_SHOW_SET_RETRIEVED, data)

      // getCoordinates({ commit }, data)
    })
    .catch((e) => {
      commit(types.COMPANY_SHOW_TOGGLE_LOADING)
      commit(types.COMPANY_SHOW_SET_ERROR, e.message)
    })
}

// export const getCoordinates = ({ commit }, data) => {
//   Vue.$geocoder.setDefaultMode('address');
//
//   var addressObj = {
//     address_line_1: data.district || '',
//     address_line_2: data.street || '' + ' ' + data.building || '',
//     city:           data.city && data.city.name,
//     state:          data.region,
//     zip_code:       data.postCode,
//     country:        data.country && data.country.name
//   }
//
//   Vue.$geocoder.send(addressObj, response => {
//     if(response && response.results && response.results[0]){
//       commit(types.COMPANY_SHOW_SET_POSITION, response.results[0].geometry.location)
//     }
//   });
// }

export const getContacts = ({ commit }, id) => {
  commit(types.COMPANY_SHOW_TOGGLE_LOADING)

  return fetch(id + '/contacts')
    .then(response => response.json())
    .then((data) => {
      commit(types.COMPANY_SHOW_TOGGLE_LOADING)
      commit(types.COMPANY_SHOW_SET_CONTACTS, data['hydra:member'])
    })
    .catch((e) => {
      commit(types.COMPANY_SHOW_TOGGLE_LOADING)
      commit(types.COMPANY_SHOW_SET_ERROR, e.message)
    })
}

export const getAddresses = ({ commit }, id) => {
  commit(types.COMPANY_SHOW_TOGGLE_LOADING)

  return fetch(id + '/addresses')
    .then(response => response.json())
    .then((data) => {
      commit(types.COMPANY_SHOW_TOGGLE_LOADING)
      commit(types.COMPANY_SHOW_SET_ADDRESSES, data['hydra:member'])
    })
    .catch((e) => {
      commit(types.COMPANY_SHOW_TOGGLE_LOADING)
      commit(types.COMPANY_SHOW_SET_ERROR, e.message)
    })
}

export const reset = ({ commit }) => {
  commit(types.COMPANY_SHOW_RESET)
}



// WEBPACK FOOTER //
// ./src/store/modules/company/show/actions.js